import dom from "../../../../../../dist/jsx-render/dom";

export class CurrentDate {
    public static createCurrentDate(element: HTMLElement) {
        let ulElements = element.querySelectorAll("[data-current-date]");

        ulElements.forEach(e => {

            let ulElement = e as HTMLElement;
            let culture = ulElement.getAttribute("data-culture");

            let date = new Date();
            let mm = date.getMonth() + 1;
            let dd = date.getDate();
            let yyyy = date.getFullYear();

            if (culture && culture.length > 0 && culture == "de") {
                ulElement.innerText = [(dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, yyyy].join('.');
            }
            else {
                ulElement.innerText = [(mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd, yyyy].join('/');
            }
        });
    }
}